$('.mainContent').on("click", ".add-to-card", function(e){
    var btn = this;
    const itemList = $(btn).parents(".tile").data("item-list");

    $.ajax({
        url: $(btn).data('href'),
        method: "POST",
        data: {
            "item": $(btn).data("item")
        },
        dataType: 'json',
        context: $('#new_item')[0],
        success: function(result) {
            if (result) {
                $('#cart-container').html(result.cart_markup);
                App.initCart();

                cardPopupShow();

                if ($(btn).data('exists') == 1) {
                    $(btn).html('<span class="iconBin"><!-- --></span>Add to Cart');
                    $(btn).data('exists', 0);
                    $(btn).data('remove-href', $(btn).data('href'));
                    $(btn).data('href', $(btn).data('add-href'));

                    removeFromCart(result.cart);

                    // admin defined callbacks for remove-from-cart event
                    try {
                        App.callbacks.removedFromCart(result.item, itemList);
                    } catch (e) {}
                } else {
                    $(btn).html('<span class="iconRemove"><!-- --></span><span>Remove<br/>from Cart</span>');
                    $(btn).data('exists',1);
                    $(btn).data('add-href',$(btn).data('href'));
                    $(btn).data('href',$(btn).data('remove-href'));

                    addToCart(result.cart);

                    try {
                        // admin defined callbacks for add-to-cart event
                        App.callbacks.addedToCart(result.item, itemList);
                    } catch (e) {

                    }
                }
            }
        },
        error: function(xhr) {
            alert('Oops! There was an error adding your item. If the problem persists, contact support.');
        }
    });

    return false;
});


// Separate handler for the model details page
$('button.btnPurchase').click(function(){
    var btn = this;

    $.ajax({
        url: $(btn).data('href'),
        dataType: 'json',
        type: "post",
        data: {
            license: $(btn).data("license"),
            item: $(btn).data("item")
        },
        success: function(result) {
            if (result) {
                addToCart(result.cart);

                $('#cart-container').html(result.cart_markup);
                cardPopupShow();

                try {
                    // admin defined callbacks for add-to-cart event
                    App.callbacks.addedToCart(result.item);
                } catch (e) {}
            }
        }
    });

    return false;
});

var cardPopupTimer = null;
var cardPopupHide = function(pop){
    $(pop).hide('slow',function(){
        $(this).attr('style',"");
    });
};
var cardPopupShow = function()
{
    if (cardPopupTimer)
    {
        clearTimeout(cardPopupTimer);
        cardPopupTimer = null;
    }

    var popBox = $('#cart-container .popupPrt');
    popBox.show('slow',function(){
        cardPopupTimer = setTimeout(function(){
            cardPopupHide(popBox);
        },3000);
    });
}

function addToCart(cartData) {
    const evt = new CustomEvent('addToCart', { detail: cartData });
    window.dispatchEvent(evt);

    window.localStorage.setItem('modelsInGeCart', cartData.count);
}

function removeFromCart(cartData) {
    const evt = new CustomEvent('removeFromCart', { detail: cartData });
    window.dispatchEvent(evt);

    window.localStorage.setItem('modelsInGeCart', cartData.count);
}
